import {Component, OnInit} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";

@Component({
    templateUrl: './erreur.component.html',
    styleUrls: ['./erreur.component.css']
})

export class ErreurModalComponent implements OnInit {

    public codeErreur: number;
    public message: string;
    public titre: string;

    public constructor(private translateService: TranslateService) {
    }

    ngOnInit() {

        this.translateService.get("ERREUR." + this.codeErreur + "." + this.message).subscribe(
            (result: string) => {
                result.includes("ERREUR.") ? this.translateService.get("ERREUR." + this.codeErreur).subscribe(
                    (result: string) => {
                        this.translateService.get("ERREUR.DEFAUT").subscribe(result => this.message = result)
                    }) : this.message = result;
            }
        );
    }
}
